// action
import {
    SAVE_INSTITUTE,
    SAVE_INSTITUTE_FAIL,
    SAVE_INSTITUTE_SUCCESS,
    SAVE_INSTITUTE_RESET
} from '../action/saveInstituteAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_INSTITUTE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_INSTITUTE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_INSTITUTE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_INSTITUTE_RESET:
            return initialState
        default:
            return state
    }
}